// Landing route Clerk redirects to after a successful Google OAuth
// roundtrip. Clerk's <AuthenticateWithRedirectCallback /> finishes the
// sign-in (exchanges the OAuth code for a session) and then sends the
// user on to the URL we asked for in signIn.authenticateWithRedirect.

import { AuthenticateWithRedirectCallback } from '@clerk/clerk-react';

export default function SSOCallback() {
  return (
    <div className="min-h-screen bg-bone flex items-center justify-center">
      <div className="text-navy text-[14px]">Completing sign-in...</div>
      <AuthenticateWithRedirectCallback />
    </div>
  );
}
